/*----- Core -----*/
import React 			 	from 'react'
import { connect } 	from "react-redux"

/*----- React Router -----*/
import {
  BrowserRouter as Router,
  Switch,
  Route,
  NavLink
} from "react-router-dom"

/*----- Styles -----*/
import Styles from './Styles'

/*----- Components -----*/
import CreateProducer from './producers/create/index'
import UpdateProducer from './producers/update/index'
import ReadProducers  from './producers/read/index'

/*----- Ant design -----*/
import { Menu } from 'antd'

/*----- Export -----*/
function Admin({match}) {
	
	return (
		<Router>
			<Styles>
			
				<article>
					<Menu
						style 							= {{ width: 256, paddingTop: 100, minHeight: '100vh' }}
						defaultOpenKeys			= {['sub1']}
						mode								= "inline"
					>
						<Menu.ItemGroup key="g1">
							<Menu.Item key="1">
								<NavLink to={`${match.url}/producers/create`} >Crear productor</NavLink>
							</Menu.Item>
							<Menu.Item key="2">
								<NavLink to={`${match.url}/producers`}>Miembros</NavLink>
							</Menu.Item>
						</Menu.ItemGroup>
				</Menu>
				</article>

				<article style={{paddingTop: 128, width: '100%'}}>
					<Switch>
						{/* <Route exact path={`${match}`} render={ () => (<Redirect to={`${match}/${ PRODUCERS }/create`}/>) }/> */}
						<Route exact path={`${match.url}/producers`} component={ ReadProducers }/>
						<Route exact path={`${match.url}/producers/create`} component={ CreateProducer }/>
						<Route exact path={`${match.url}/producers/:id/update`} component={ UpdateProducer} />
					</Switch>
				</article>

			</Styles>
		</Router>
	)

}

const mapStateToProps = (state) => {
  return {
		location: state.router
	}
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Admin)
